/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPaymentByUserIdRequestLimit
 */
export interface GetPaymentByUserIdRequestLimit {
}

/**
 * Check if a given object implements the GetPaymentByUserIdRequestLimit interface.
 */
export function instanceOfGetPaymentByUserIdRequestLimit(value: object): value is GetPaymentByUserIdRequestLimit {
    return true;
}

export function GetPaymentByUserIdRequestLimitFromJSON(json: any): GetPaymentByUserIdRequestLimit {
    return GetPaymentByUserIdRequestLimitFromJSONTyped(json, false);
}

export function GetPaymentByUserIdRequestLimitFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPaymentByUserIdRequestLimit {
    return json;
}

export function GetPaymentByUserIdRequestLimitToJSON(json: any): GetPaymentByUserIdRequestLimit {
    return GetPaymentByUserIdRequestLimitToJSONTyped(json, false);
}

export function GetPaymentByUserIdRequestLimitToJSONTyped(value?: GetPaymentByUserIdRequestLimit | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

